import React from 'react';
import PdfScoring from './PdfScoring';

export default function ScoringMatrix({ sectionsConfig, matrixData }) {
  const sectionTitle =
    sectionsConfig.find((section) => section.key === 'scoring_matrix')?.title ||
    'Scoring Matrix';

  return (
    <>
      <div className={'fund-wrap-web m-2 mt-2 p-3'}>
        <p className="web-header-scoring">{sectionTitle}</p>
      </div>
      <div className={'fund-wrap-content m-2 mt-2 p-3'}>
        <div className="d-flex  justify-content-between align-items-center">
          <div className="recomandation-content">
            <PdfScoring fundData={matrixData} />
          </div>
        </div>
      </div>
    </>
  );
}
